import { Headers } from '@egw/components'
import { InvestmentOverviewRedesignPage } from '@egw/features-investment'
import { useTranslation } from '@egw/i18n'
import { Layout } from '@egw/layouts'
import { type FC } from 'react'

export const InvestmentOverviewPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Layout>
      <Headers title={t('pages.overview.title')} />
      <InvestmentOverviewRedesignPage />
    </Layout>
  )
}
